<template>
    <!-- 新增活动兑换码 -->
    <content-view>
        <div class="wrap-container-in">
            <a-form :form="form">
                <a-form-item label="所属活动名称" :label-col="{ span: 8 }" :wrapper-col="{ span: 8 }">
                    <a-input
                        placeholder="请输入"
                        v-decorator="['activityName', {rules: [{ required: true, message: '请输入所属活动名称'}]}]"
                    />
                </a-form-item>
                <a-form-item label="选择奖品类型" :label-col="{ span: 8 }" :wrapper-col="{ span: 8 }">
                    <a-select @change="onChangeType" v-decorator="['prizeType', {rules: [{ required: true, message: '请选择奖品类型' }]}]" placeholder="请选择">
                        <a-select-option :value="1">线上票</a-select-option>
                        <a-select-option :value="2">线下票</a-select-option>
                        <a-select-option :value="3">优惠券</a-select-option>
                        <a-select-option :value="4">储值卡</a-select-option>
                        <a-select-option :value="5">新优惠券</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="选择奖品" :label-col="{ span: 8 }" :wrapper-col="{ span: 8 }" required>
                    <a-select v-decorator="['prizeId', {rules: [{ required: true, message: '请选择奖品' }]}]" placeholder="请选择">
                        <a-select-option v-for="item in prizeListData" :key="item.prizeId" :value="item.prizeId">{{item.prizeName}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="生成数量" :label-col="{ span: 8 }" :wrapper-col="{ span: 8 }" required>
                    <a-input-number
                        :min="1"
                        :precision="0"
                        style="width:100%"
                        placeholder="请输入"
                        v-decorator="['prizeNum', {rules: [{ required: true, message: '请输入生成数量' }]}]"
                    />
                </a-form-item>
                <a-form-item label="是否限期" :label-col="{ span: 8 }" :wrapper-col="{ span: 8 }" required>
                    <a-radio-group
                        @change="onChangeDate"
                        v-decorator="['expiryDate',{initialValue: 0}]"
                    >
                        <a-radio :value="0">不限期</a-radio>
                        <a-radio :value="1">限期</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item v-show="showDate" label="设置兑换码有效期" :label-col="{ span: 8 }" :wrapper-col="{ span: 8 }">
                    <a-range-picker style="width:100%" format="YYYY－MM－DD" v-decorator="['validityDate', {rules: [{ required: showDate, message: '请设置兑换码有效期' }]}]"/>
                </a-form-item>
                <a-form-item class="text-center">
                    <a-button @click="$router.go(-1)">取消</a-button>
                    <a-button :loading="loading" class="mr8" type="primary" @click="submit">确认生成</a-button>
                </a-form-item>
            </a-form>
        </div>
    </content-view>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    export default {
        name: 'addCode',
        components: {},
        props: {},
        data() {
            return {
                form: this.$form.createForm(this), //添加和编辑表单
                showDate: false,
                prizeListData: [],
                loading: false
            };
        },
        beforeCreate() {},
        watch: {},
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            onChangeDate(e) {
                this.showDate = e.target.value === 1
                this.$nextTick(() => {
                    this.form.validateFields(['memberPrice'], { force: true });
                });
            },
            onChangeType(value) {
                this.form.setFieldsValue({
                    prizeType: undefined,
                    prizeId: undefined,
                })
                this.prizeList(value)
            },
            prizeList(prizeType) {
                this.$api.changeCode.prizeList({
                    body: {
                        prizeType: prizeType,
                        shopId: this.shopId
                    }
                }).then(res => {
                    this.prizeListData = res
                })
            },
            submit() {
                this.form.validateFields((err, values) => {
                    if (err) return
                    values.shopId = this.shopId

                    const validity = values['validityDate'] ? values['validityDate'] : []
                    values.validityStart = validity.length > 0 ? validity[0].format('YYYY-MM-DD 00:00:00') : ''
                    values.validityEnd = validity.length > 0 ? validity[1].format('YYYY-MM-DD 23:59:59') : ''
                    delete values.validityDate

                    values.prizeName = this.prizeListData.filter(item => item.prizeId === values.prizeId)[0].prizeName

                    this.loading = true
                    this.$api.changeCode.generate({
                        body: values
                    }).then(data=>{
                        this.$message.success('奖品兑换码正在生成中，生成完成后系统会发送短信通知您，亲注意查收哦～')
                        this.loading = false
                        this.$router.go(-1);
                    }).catch(err => {
                        this.loading = false
                    })
                });
            },
        },
        created() {},
        mounted() {},
        watch: {
            shopId() {
                this.form.setFieldsValue({
                    prizeType: undefined,
                    prizeId: undefined,
                })
                // this.prizeList()
            }
        }
    };
</script>
<style lang="scss">
</style>
